import { CartButton, HERO_GRADIENT, HERO_SHELL } from "@/store/components/Header";

function Shimmer({ className }: { className: string }) {
  return <div className={`agd:animate-pulse agd:rounded-md agd:bg-[#e2e8f0] ${className}`} />;
}

function ShimmerLight({ className }: { className: string }) {
  return <div className={`agd:animate-pulse agd:rounded-md agd:bg-white/25 ${className}`} />;
}

function SkeletonStat() {
  return (
    <div className="agd:flex-1 agd:basis-[100px] agd:shrink-0 agd:rounded-xl agd:bg-card agd:px-5 agd:py-3.5 agd:shadow-md">
      <Shimmer className="agd:mb-2 agd:h-6 agd:w-1/2" />
      <Shimmer className="agd:h-2.5 agd:w-3/4" />
    </div>
  );
}

function SkeletonPill({ className }: { className: string }) {
  return <div className={`agd:h-9 agd:shrink-0 agd:rounded-full agd:bg-card agd:shadow-[0_1px_3px_rgba(0,0,0,.06)] ${className}`} />;
}

function SkeletonCard() {
  return (
    <div className="agd:flex agd:flex-col agd:overflow-hidden agd:rounded-[10px] agd:border agd:border-border agd:bg-card agd:shadow-sm">
      <Shimmer className="agd:mx-2 agd:mt-2 agd:h-[120px] agd:w-[calc(100%-16px)]" />
      <div className="agd:flex agd:flex-col agd:px-5 agd:pb-5 agd:pt-3.5">
        <Shimmer className="agd:mb-2.5 agd:h-2.5 agd:w-[38%]" />
        <Shimmer className="agd:mb-3.5 agd:h-4 agd:w-4/5" />
        <Shimmer className="agd:mb-2 agd:h-3 agd:w-full" />
        <Shimmer className="agd:mb-2 agd:h-3 agd:w-full" />
        <Shimmer className="agd:mb-3.5 agd:h-3 agd:w-[55%]" />
        <Shimmer className="agd:mb-3 agd:h-[18px] agd:w-[45%]" />
        <Shimmer className="agd:h-10 agd:w-full" />
      </div>
    </div>
  );
}

/** Skeleton placeholder shown while the store data loads (mirrors the loaded layout). */
export default function LoadingState() {
  return (
    <div className="agd:mb-8 agd:max-md:mb-5">
      <div className={HERO_SHELL} style={HERO_GRADIENT}>
        <div className="agd:flex agd:flex-wrap agd:items-start agd:justify-between agd:gap-3 agd:max-md:flex-col">
          <div>
            <h1 className="agd:m-0 agd:text-[27px] agd:font-extrabold agd:text-white agd:max-md:text-[19px]">
              AGD Store
            </h1>
            <ShimmerLight className="agd:mt-2.5 agd:h-3 agd:w-64" />
          </div>
          <CartButton />
        </div>
      </div>

      <div className="agd:relative agd:z-10 agd:-mt-8 agd:px-2 agd:max-md:-mt-[22px] agd:max-md:px-0">
        <div className="agd:flex agd:flex-wrap agd:gap-4">
          <SkeletonStat />
          <SkeletonStat />
          <SkeletonStat />
          <SkeletonStat />
        </div>
      </div>

      <div className="agd:mt-6 agd:flex agd:flex-wrap agd:gap-2.5">
        <SkeletonPill className="agd:w-16" />
        <SkeletonPill className="agd:w-28" />
        <SkeletonPill className="agd:w-24" />
        <SkeletonPill className="agd:w-32" />
        <SkeletonPill className="agd:w-20" />
      </div>
      <div className="agd:grid agd:gap-5" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 300px), 1fr))" }}>
        {Array.from({ length: 6 }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    </div>
  );
}
